<template>
  <CockpitDialog
    class="fixed top-200px left-500px w-800px h-600px"
    v-if="visible"
    :title="title + '处置方法应急卡'"
    @close="close"
  >
    <div class="w-full h-full">
      <div class="w-full h-full relative z-9999">
        <el-table
          :data="equipDataList"
          class="w-full"
          :height="tableHeight"
          v-loading="equipTableLoading"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="卡片名称"
            prop="cardName"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="编号"
            prop="cardNum"
            width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="发生区域"
            prop="occurredAreaStr"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="事故类型" prop="accidentTypeStr" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="可能导致的事故"
            prop="mayResultAccidentsStr"
            show-overflow-tooltip
          ></el-table-column>
          <!-- 没有主管单位字段 -->
          <!-- <el-table-column label="主管单位" prop="competentUnit" show-overflow-tooltip>
          </el-table-column> -->
          <!-- 没有主要负责人字段 -->
          <!-- <el-table-column
            label="主要负责人"
            prop="principalChargePerson"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <!-- 没有现场负责人字段 -->
          <!-- <el-table-column label="现场负责人" prop="fieldManager" width="100" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" @click.native="handleView(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <!-- <div slot="empty" class="w-full h-full flex justify-center items-center">
            <img src="../../../assets/images/no_data@1x.png" alt="" />
          </div> -->
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="equipTotalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <CockpitDialog
      class="fixed top-200px left-500px w-900px h-600px !z-10000"
      v-if="detailVisible"
      :title="'查看处置方法应急卡'"
      @close="detailVisible = false"
    >
      <div class="w-full h-full relative z-10000 overflow-y-auto">
        <div class="pdf-panel px-10px pt-20px" ref="card">
          <div class="w-full text-3xl text-center h-60px leading-60px bg-color-primary">
            处置方法应知卡
          </div>
          <div class="table-form border-1 border-color-default">
            <table class="table-body w-full">
              <tr>
                <td
                  rowspan="9"
                  class="w-1/6 border-r-1 border-b-1  border-l-1 p-10px table-cell bg-table-header"
                >
                  <div>
                    事故风险分析
                  </div>
                </td>
              </tr>
              <tr class="w-5/6  ">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                  <div>事故类型</div>
                </td>
                <td
                  colspan="5"
                  class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header"
                >
                  <div class="font-normal">
                    {{ formData.accidentTypeStr }}
                  </div>
                </td>
              </tr>
              <tr class="">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div>发生的区域</div>
                </td>
                <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div class="font-normal">
                    {{ formData.occurredAreaStr }}
                  </div>
                </td>
              </tr>
              <tr class=" ">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                  <div>可能导致的事故</div>
                </td>
                <td
                  colspan="5"
                  class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header"
                >
                  <div class="font-normal">
                    {{ formData.mayResultAccidentsStr }}
                  </div>
                </td>
              </tr>
              <tr class="">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div>可能发生的时间</div>
                </td>
                <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div class="font-normal">
                    {{ formData.occurrencePossibleTime }}
                  </div>
                </td>
              </tr>
              <tr class=" ">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                  <div>影响范围</div>
                </td>
                <td
                  colspan="5"
                  class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header"
                >
                  <div class="font-normal">
                    {{ formData.influenceScope }}
                  </div>
                </td>
              </tr>
              <tr class="">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div>具体位置</div>
                </td>
                <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div class="font-normal">
                    {{ formData.specificLocations }}
                  </div>
                </td>
              </tr>
              <tr class=" ">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                  <div>出现的征兆</div>
                </td>
                <td
                  colspan="5"
                  class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header"
                >
                  <div class="font-normal">
                    {{ formData.appearanceSigns }}
                  </div>
                </td>
              </tr>
              <tr class="">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div>次生、衍生事故</div>
                </td>
                <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div class="font-normal">
                    {{ formData.derivativeAccidents }}
                  </div>
                </td>
              </tr>
              <tr class="">
                <td
                  class="w-1/6 border-r-1 border-b-1  border-l-1 p-10px table-cell bg-table-header"
                >
                  <div>应急工作职责</div>
                </td>
                <td
                  colspan="5"
                  class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header"
                >
                  <div class="font-normal">
                    {{ formData.emergencyResponseTaskForceResponsibilities }}
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  rowspan="5"
                  class="w-1/6 border-r-1 border-l-1 border-b-1 p-10px table-cell bg-white"
                >
                  <div class="text-color-primary">
                    应急处置
                  </div>
                </td>
              </tr>
              <tr class="w-5/6 ">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div>应急处置程序</div>
                </td>
                <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div class="font-normal">
                    {{ formData.emergencyProcedures }}
                  </div>
                </td>
              </tr>
              <tr class=" ">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                  <div>现场应急处置措施</div>
                </td>
                <td
                  colspan="5"
                  class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-table-header"
                >
                  <div class="font-normal">
                    {{ formData.onSiteDisposalMeasures }}
                  </div>
                </td>
              </tr>
              <tr class="">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div>报警电话</div>
                </td>
                <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div class="font-normal">
                    {{ formData.policeCall }}
                  </div>
                </td>
              </tr>
              <tr class=" ">
                <td class="w-1/6 border-r-1 border-b-1 p-10px table-cell bg-table-header">
                  <div>事故报告等</div>
                </td>
                <td
                  colspan="5"
                  class="w-5/6 border-r-1 border-b-1 p-10px table-cell  bg-table-header"
                >
                  <div class="font-normal">
                    {{ formData.accidentReportContents }}
                  </div>
                </td>
              </tr>
              <tr class="">
                <td class="w-1/6 border-r-1 border-b-1 border-l-1 p-10px table-cell bg-white">
                  <div>注意事项</div>
                </td>
                <td colspan="5" class="w-5/6 border-r-1 border-b-1 p-10px table-cell bg-white">
                  <div class="font-normal">
                    {{ formData.precautions }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </CockpitDialog>
  </CockpitDialog>
</template>

<script>
import { DisposalMethodEmergencyCardApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import CockpitDialog from '../../../../../components/cockpit/CockpitDialog'

const disposalMethodEmergencyCardApi = new DisposalMethodEmergencyCardApi()

export default {
  name: 'dispose-card-list',
  components: {
    CockpitDialog,
  },
  props: {
    areaId: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: true,
      detailVisible: false,
      formData: {
        cardName: '',
        cardNum: '',
        accidentType: null,
        occurredAreaId: undefined,
        occurrencePossibleTime: undefined,
        influenceScope: '',
        mayResultAccidents: '',
        specificLocations: '',
        appearanceSigns: '',
        derivativeAccidents: '',
        emergencyResponseTaskForceResponsibilities: '',
        emergencyProcedures: '',
        onSiteDisposalMeasures: '',
        policeCall: null,
        accidentReportContents: '',
        precautions: '',
      },
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        ownedUnitId: '',
        areaId: this.areaId,
        evaluationLevel: '',
        riskPointType: 0,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 60px)'
    },
  },
  mounted() {
    this.getEquipList()
  },
  methods: {
    async handleView(row) {
      const [err, res] = await disposalMethodEmergencyCardApi.get(row.id)
      if (!err) {
        this.formData = {
          ...this.formData,
          ...res,
        }
        this.formData.occurrencePossibleTime = this.formData.occurrencePossibleTime
          ? dayjs(this.formData.occurrencePossibleTime).format('YYYY-MM-DD HH:mm:ss')
          : undefined
        this.detailVisible = true
      }
    },
    // 切换查询
    changeValues(values) {
      this.handleSearch()
    },
    // 关闭弹窗
    close() {
      this.$emit('cancel')
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      const data = {
        occurredAreaId: this.areaId,
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await disposalMethodEmergencyCardApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/styles/filterSelect.scss';
</style>
<style scoped lang="scss">
@import '../../../assets/styles/input.scss';
@import '../../../assets/styles/table.scss';
@import '../../../assets/styles/pagination.scss';
@import '../../../assets/styles/shadow.scss';
@import '../../../assets/styles/button.scss';
@import '../../../assets/styles/dialog.scss';
@import '../../../assets/styles/loading.scss';

::v-deep .round-button {
  line-height: 1;
}
::v-deep .el-button {
  background-image: var(--cockpitButtonBg) !important;
}
::v-deep .el-input__inner {
  border: none;
}
// ::v-deep .el-table__empty-text {
//   display: block;
//   height: 100%;
//   width: 100%;
// }
.table-form {
  .table-body {
    word-break: break-all;
    font-size: 14px;
    tr:last-child {
      border: none;
    }
  }
  ::v-deep .el-card .el-card__header {
    padding: 10px;
  }

  ::v-deep .custom-card {
    border-bottom: none !important;
  }

  ::v-deep .el-card .el-card__header {
    padding: 0 !important;
  }
}
</style>
